const isNotEmpty = value => {
    if (typeof value === 'undefined' || value === '' || value === null) {
        return false;
    }
    return true;
};

module.exports = isNotEmpty;
